import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import MaterialTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import clsx from "clsx";
const useStyles = makeStyles(({
  typography
}) => ({
  cell: {
    padding: `${typography.pxToRem(15)} ${typography.pxToRem(15)} ${typography.pxToRem(15)} ${typography.pxToRem(30)}`,
    borderBottom: 0
  },
  headerCell: {
    color: "#1d9ad0",
    fontSize: typography.pxToRem(20),
    letterSpacing: 0.44,
    lineHeight: 0.86,
    fontWeight: typography.pxToRem(400)
  },
  contentCell: {
    fontWeight: typography.pxToRem(300),
    fontSize: typography.pxToRem(15),
    letterSpacing: 0.44,
    "&+&": {
      borderLeft: `${typography.pxToRem(2)} solid #979797`
    }
  }
}));

const Table = ({
  titles,
  data,
  rowMap,
  className
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(MaterialTable, {
    className: clsx(styles.table, className),
    "aria-label": "simple table"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, titles.map((title, index) => {
    const {
      value,
      className
    } = title;
    return /*#__PURE__*/React.createElement(TableCell, {
      key: index,
      className: clsx(styles.cell, styles.headerCell, className)
    }, value);
  }))), /*#__PURE__*/React.createElement(TableBody, {
    classes: {
      root: styles.body
    }
  }, data.map((row, rowIdx) => /*#__PURE__*/React.createElement(TableRow, {
    key: rowIdx
  }, rowMap(row).map(({
    value,
    className
  }, i) => /*#__PURE__*/React.createElement(TableCell, {
    key: i,
    className: clsx(styles.cell, styles.contentCell, className)
  }, value))))));
};

export default Table;